// extracted by mini-css-extract-plugin
export default {"property_details_flex":"AgentOverview_property_details_flex__YykNM","property_details":"AgentOverview_property_details__wpteL"};